/** Old link to one RSW report: carried over, filters and all, to the one warehouse list at RSW. */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/rsw/$key")({
  validateSearch: reportSearch,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/reports/warehouse/$slug",
      params: { slug: params.key },
      search: { ...search, stage: "raw" },
      replace: true,
    });
  },
});
